import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { BrowserRouter as Router, Route, Switch, Link } from 'react-router-dom';
import { RootViewProvider as Root, DefaultTemplate } from '@fingermarkglobal/cringer.components';
import { buildRoutes } from './utilities';
import { HistoryProvider, useHistoryStack } from './HistoryProvider';

import { base } from './config';

const RouteBuilder = ({ Template = DefaultTemplate, root = {}, config = base }) => {
  const RoutesContainer = () => {
    const flags = useFlags();
    config.cart.config.provider = {
      ...config.cart.config.provider,
      ...{ showOrderTotalSummary: !!flags.kioskEnableOrderTotalSummary },
    };

    const routes = buildRoutes({ config, Template, Route });

    return (
      <Switch>
        {routes.map(route => {
          // This needs to be inlined as components get wrapped in fragments which breaks routing
          // https://github.com/remix-run/react-router/issues/5785
          // this is all to allow `404` pages to work
          const { Route, Template, View, Provider, url, config } = route;

          return (
            <Route key={url} exact path={url}>
              <Template {...(config?.template || {})}>
                <Provider {...(config?.provider || {})}>
                  <View {...(config?.props || {})} />
                </Provider>
              </Template>
            </Route>
          );
        })}
      </Switch>
    );
  };

  return (
    <Router>
      <HistoryProvider>
        <Root {...root}>
          <RoutesContainer />
        </Root>
      </HistoryProvider>
    </Router>
  );
};

export { RouteBuilder, base, Link, useHistoryStack };
